import { render } from "./MailIcon.vue?vue&type=template&id=38389171"
import script from "./MailIcon.vue?vue&type=script&lang=js"
export * from "./MailIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__